import { apiRequest } from '@peruselab/api-client/httpRequest';
import type { Protein } from './Protein';

export async function getProtein(id: string): Promise<Protein> {
  return apiRequest<Protein>(`/proteins/${encodeURIComponent(id)}`, 'protein');
}
